import { Row, Col, Container } from "react-bootstrap";
import Card from "../../../components/Card";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import Error500 from "../errors/error500";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Oval } from "react-loader-spinner";
import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";

const Notification = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apierror, setApiError] = useState(false);
  const users = JSON.parse(localStorage.getItem("users"));
  const token = localStorage.getItem("token");

  console.log(users);

  useEffect(() => {
    document.body.classList.add("notification");
    return () => {
      document.body.classList.remove("notification");
    };
  }, []);

  const getAllData = async () => {
    try {
      const response = await axios.post(
        webServiceUrl.getNotifications,
        {
          users,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setData(response.data.data);
    } catch (error) {
      toast.error("Network Error");
      console.error("Error Fetching Notification", error);
      setApiError(true);
    } finally {
      setTimeout(() => setIsLoading(false), 1500);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <div
      id="content-page"
      className="content-inner notification_container_main"
    >
      <Container>
        <Row>
          <Col sm="12">
            <h4 className="card-title mb-4">🔔 Announcements</h4>
          </Col>
          <Col sm="12">
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "200px" }}
              >
                <Oval
                  height="50"
                  width="50"
                  color="#4fa94d"
                  secondaryColor="#4fa94d"
                />
              </div>
            ) : apierror ? (
              <Error500 />
            ) : data.length === 0 ? (
              <p className="text-center fs-5 text-muted mt-3">
                No notifications available.
              </p>
            ) : (
              data.map((notif) => (
                <>
                  <>
                    {/* Desktop view (sm and up) */}
                    <div className="d-none d-sm-block">
                      <Card
                        key={notif.id}
                        className="mb-3 border-0 shadow-sm notification-card"
                      >
                        <Card.Body>
                          <div className="d-flex align-items-center">
                            <img
                              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                                notif.name,
                              )}&background=3d8629&color=fff`}
                              alt="notification-avatar"
                              className="rounded-circle me-3"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                              }}
                            />
                            <div className="flex-grow-1">
                              <h6 className="mb-1">
                                <strong>{notif.name}</strong>{" "}
                                <span
                                  className="text-muted mb-0 ms-3"
                                  style={{ fontSize: "0.875rem" }}
                                >
                                  {formatDistanceToNow(new Date(notif.date), {
                                    addSuffix: true,
                                  })}
                                </span>
                              </h6>
                              <div className="text-muted my-1">
                                {notif.message}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>

                    {/* Mobile view (xs only) */}
                    <div className="d-block d-sm-none">
                      <Card
                        key={notif.id}
                        className="mb-3 border-0 shadow-sm notification-card"
                      >
                        <Card.Body>
                          <div className="d-flex gap-3">
                            <img
                              src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                                notif.name,
                              )}&background=3d8629&color=fff`}
                              alt="notification-avatar"
                              className="rounded-circle mb-2"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                              }}
                            />
                            <div className="d-flex flex-column">
                              <h6 className="mb-1">
                                <strong>{notif.name}</strong>{" "}
                              </h6>
                              <div>
                                <span
                                  className="text-muted mb-0"
                                  style={{ fontSize: "0.875rem" }}
                                >
                                  {formatDistanceToNow(new Date(notif.date), {
                                    addSuffix: true,
                                  })}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="text-muted my-1">{notif.message}</div>
                        </Card.Body>
                      </Card>
                    </div>
                  </>
                </>
              ))
            )}
          </Col>
        </Row>
      </Container>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        style={{ fontSize: "15px" }}
      />
    </div>
  );
};

export default Notification;